import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { NoteFragmentDoc } from '../../queries/generated/notes';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UpdateNoteMutationVariables = Types.Exact<{
  input: Types.UpdateNoteInput;
}>;


export type UpdateNoteMutation = { updateNote: { note: { id: string, title?: string | null, description?: string | null, plainText?: string | null, rootBlockId?: string | null, status?: Types.NoteStatusTypeEnum | null, reviewConfig?: { reviewStatus?: Types.NoteReviewStatusTypeEnum | null } | null } } };


export const UpdateNoteDocument = /*#__PURE__*/ gql`
    mutation updateNote($input: UpdateNoteInput!) {
  updateNote(input: $input) {
    note {
      ...Note
    }
  }
}
    ${NoteFragmentDoc}`;

export function useUpdateNoteMutation() {
  return Urql.useMutation<UpdateNoteMutation, UpdateNoteMutationVariables>(UpdateNoteDocument);
};